// extracted by mini-css-extract-plugin
export default {"container":"style_container__LoooH","selector":"style_selector__LrO2L"};